export function mapOnto<T, U>(arr: T[], onto: U[], callbackfn: (value: T, index: number, array: T[]) => U): U[] {
    if (!onto) return arr.map(callbackfn);
    if (onto.length > arr.length) onto.splice(arr.length);
    for (let i = 0; i < arr.length; i++) {
        onto[i] = callbackfn(arr[i], i, arr);
    }
    return onto;
}